import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasProperty'
})

export class HasPropertyPipe implements PipeTransform{

  transform(object: any, property: string): boolean {
    return object.hasOwnProperty(property);
  }

};
